// Optimized: Only load English and Spanish for widget
// Original file backed up at index.js.backup
// To restore all languages: cp index.js.backup index.js

import en from './locale/en.json';
import es from './locale/es.json';

export default {
  en,
  es,
};
